'use strict';

var logger = {
	log: function (message, level) {
		if (message) {
			var url = window.Urls.loggerLog;
			$.ajax({
				type: 'POST',
				dataType: 'json',
				url: url,
				data: {
					message: message,
					level: level
				}
			}).done(function (response) {
				window.console.log('Call logger \nmessage: ' + message + '\nlevel: ' + level, '\nresponse: ' + response);
			});
		}
	}
};

module.exports = logger;
